export default __webpack_public_path__ + "static/media/close-legend-mobile.f7e653ea.svg";